import React, { useState } from "react";
import { Card, Chip, EmptyState, Button, Skeleton, fmtCoins } from "../../components/ui";
import { useAsync } from "../../hooks";
import content from "../../services/api-content";
import "../../styles/content.css";

const LABEL = {
  users: "ผู้ใช้ทั้งหมด", newUsers: "ผู้ใช้ใหม่", topupAmount: "ยอดเติมเงิน (บาท)", topupCount: "จำนวนรายการเติมเงิน", coinsSpent: "คอยน์ที่ใช้", messages: "ข้อความ",
  characters: "ตัวละคร", chats: "ห้องแชท", coinsInCirculation: "คอยน์ในระบบ",
};

function Bars({ days, k, title, unit = "" }) {
  const max = Math.max(1, ...days.map((d) => Number(d[k]) || 0));
  return (
    <Card>
      <div className="strong">{title}</div>
      <div className="bars" role="img" aria-label={`${title} รายวัน`}>
        {days.map((d) => <i key={d.date} data-tip={`${d.date}: ${fmtCoins(d[k])}${unit}`} style={{ height: `${Math.max(3, ((Number(d[k]) || 0) / max) * 100)}%` }} />)}
      </div>
      <div className="row-between faint" style={{ fontSize: 11 }}><span>{days[0]?.date}</span><span>{days[days.length - 1]?.date}</span></div>
    </Card>
  );
}

export default function AdminHome() {
  const [n, setN] = useState(14);
  const { data, loading, error, reload } = useAsync(() => content.admin.stats(n), [n]);
  if (error) return <EmptyState icon="⚠️" title="โหลดสถิติไม่สำเร็จ" action={<Button onClick={reload}>ลองใหม่</Button>}><span className="error-text">{error}</span></EmptyState>;
  const days = data?.days || [];
  const totals = Object.entries(data?.totals || {}).filter(([, v]) => typeof v === "number");
  return (
    <div className="stack" style={{ gap: 16 }}>
      <div className="chip-row">{[7, 14, 30].map((d) => <Chip key={d} active={n === d} onClick={() => setN(d)}>{d} วัน</Chip>)}</div>
      {loading ? <Skeleton height={100} /> : (
        <>
          <div className="kpi">{totals.map(([k, v]) => <Card key={k}><div className="stat"><b>{fmtCoins(v)}</b><span>{LABEL[k] || k}</span></div></Card>)}</div>
          {days.length ? (
            <div className="grid-cards" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))" }}>
              <Bars days={days} k="newUsers" title="ผู้ใช้ใหม่รายวัน" />
              <Bars days={days} k="topupAmount" title="ยอดเติมเงินรายวัน (บาท)" />
              <Bars days={days} k="messages" title="ข้อความรายวัน" />
            </div>
          ) : <Card className="muted">ยังไม่มีข้อมูลรายวัน</Card>}
        </>
      )}
    </div>
  );
}
